
import { Vue, Component } from 'vue-property-decorator'
import Company from '@/types/company'
import AfasField from '@/components/afas/AfasField.vue'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { AfasField }
})

export default class CompanyShowDetailsTab extends Vue {
  settings = {
    routeNames: { list: 'companies', show: 'companyShow', edit: 'companyEdit' },
    routeParamKey: 'companyId',
    functionNames: { setCurrent: 'setCurrentCompany', save: 'saveCompany' },
    getterNames: { current: 'currentCompany', loading: 'loadingCompany', errors: 'projectErrors' }
  }

  get currentItem () : Company {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get isAfasCompany () : boolean {
    return this.currentItem.in_afas
  }

  get activeIconType () : string {
    return this.currentItem.active ? 'check' : 'close'
  }

  get activeIconClass () : string {
    return this.currentItem.active ? 'wo-green-text' : 'wo-red-text'
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
